export default "__VITE_ASSET__BdkXAFrc__"